import actionTypes from '../actionTypes'

const initialState = {
  iframeReady: false,
  sessionRequest: null,
  randomSessionIdentifier: null,
  accessToken: null,
  error: null,
}

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case actionTypes.START:
      return {
        ...state,
        iframeReady: true,
        error: initialState.error,
      }
    case actionTypes.SET_SESSION_REQUEST:
      return {
        ...state,
        sessionRequest: action.payload,
        error: initialState.error,
      }
    case actionTypes.SET_RANDOM_SESSION_IDENTIFIER:
      return {
        ...state,
        sessionRequest: null,
        randomSessionIdentifier: action.payload,
        error: initialState.error,
      }
    case actionTypes.SET_ACCESS_TOKEN:
      return {
        ...state,
        sessionRequest: null,
        accessToken: action.payload,
        error: initialState.error,
      }
    case actionTypes.SET_ERROR:
      return {
        ...state,
        error: action.payload,
      }
    case actionTypes.SIGN_OUT:
      return {
        ...initialState,
        iframeReady: true,
      }
    default:
      return state
  }
}
